// generate test id
// Example:
//     computedBindTo:
// "userAction.sectionTest.a518109e-8f1a-1610-4cd2-a20091faa043.targetInput"
// truePath:
//     ["entities", 3, "entities", 5, "entities", 10, "properties"]
// will be transformed to:

import { WEBUILogs } from "../../../tinqin-utils/src/logging";

//     "userAction.sectionTest.5.targetInput"
export function getDataTqId(props) {
    if (!props) {
        WEBUILogs.log("Calling getDataTqId with empty parameter");
        return;
    }
    let bindTo = props.computedBindTo;
    let truePath = props.truePath;
    let data = props.data;
    let resultId;
    if (data && bindTo && truePath) {
        // split bindTo : make array and remove first element
        let bindToArray = bindTo.split(".");
        let stepName = bindToArray.shift();
        // get only numbers from truePath
        let numbers = truePath.filter(function(element) {
            return element !== "entities" && element !== "properties";
        });
        // replace uuid with numbers and fill result array
        let newBindTo = [];
        if (bindToArray.length === numbers.length) {
            bindToArray.forEach(function(element, index) {
                let newElement = isUUID(element) ? numbers[index] : element;
                newBindTo.push(newElement);
            });
        }
        resultId = stepName + "." + newBindTo.join(".");
        return resultId;
    }
    return resultId;
}

function isUUID(stringToTest) {
    if (stringToTest[0] === "{") {
        stringToTest = stringToTest.substring(1, stringToTest.length - 1);
    }
    //eslint-disable-next-line
    let regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(stringToTest);
}
